import { SEARCH_TYPES } from 'src/services/constants';

/**
 * Search related boot actions.
 */
export default async ({ router, store }) => {
  router.beforeEach(async ({ matched }, { matched: oldMatched }, next) => {
    if (!store.state.filtering.filtersInitialized) {
      // Do nothing until filters are initialized
      next();
      return;
    }

    const rootPath = matched?.[0]?.path;
    const previousRootPath = oldMatched?.[0]?.path;

    if (rootPath !== previousRootPath && (store.state.search.searchType !== SEARCH_TYPES.EXTERNAL || rootPath !== '')) {
      // Clear Universal Search filters before transitioning to a new route
      await store.dispatch('search/setSearchType', SEARCH_TYPES.KEYWORD, { root: true });
      await store.dispatch('filtering/filterByTerm', '', { root: true });
      await store.dispatch('search/updateFilterTerms', '', { root: true });
      await store.dispatch('search/setSearchItems', [], { root: true });
    }

    next();
  });
};
